import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  accessToken: "",
  isAuthenticated: false,
  isFirstTimeLogin: false,
  user: {},
};

const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    login: (state, { payload }) => {
      state.accessToken = payload.accessToken;
      state.user = payload.user;
      state.isAuthenticated = true;
      state.isFirstTimeLogin =
        payload.user.isFirstTimeLogin.toLowerCase() === "true";
    },
    logOut: (state) => {
      state.accessToken = "";
      state.isAuthenticated = false;
      state.user = {};
      state.isFirstTimeLogin = false;
    },
    setIsFirstTimeLogin: (state, { payload }) => {
      state.isFirstTimeLogin = payload;
    },
    updateUserDetails: (state, { payload }) => {
      state.user = payload.user;
    },
  },
});

export const { login, logOut, setIsFirstTimeLogin, updateUserDetails } =
  authSlice.actions;

export const selectIsAuthenticated = (state: any) => state.auth.isAuthenticated;

export const selectAccessToken = (state: any) => state.auth.accessToken;

export const selectUser = (state: any) => state.auth.user;
export const selectIsFirstTimeLogin = (state: any) =>
  state.auth.isFirstTimeLogin;

export default authSlice.reducer;
